"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash.merge"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

// Type definition overload is required to support different number of arguments
// Typescript will pick the correct version based on the number of arguments
// This is based on the official lodash types, here's a link to it:
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/65d953cfe06db5c867630bccb1ad2eadff3fd570/types/lodash/common/object.d.ts#L1714

/**
 * Merges more objects' properties together recursively
 * @param objects - array of objects to merge in order
 */
var mergeProps = function mergeProps() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  return _lodash.default.apply(void 0, [{}].concat(objects));
};
var _default = exports.default = mergeProps;